import styled, { css } from 'styled-components';
import { Color } from 'src/utils/theme';
import { Icon } from 'src/components';

export const StickyHeader = styled.div(
  ({ theme }) => css`
    z-index: ${theme.zi.z6};
    position: fixed;
    width: 100%;
  `,
);

export const Container = styled.div<{ $embedded?: boolean }>(
  ({ theme, $embedded }) => css`
    width: 100%;
    display: flex;
    justify-content: center;

    ${
      $embedded
        ? css`
            min-height: 0;
            padding: 0;
            background-color: transparent;
          `
        : css`
            min-height: 100vh;
            padding: ${theme.sz.s24} ${theme.sz.s4} ${theme.sz.s0} ${theme.sz.s4};
            background-color: ${theme.co.primary98};

            @media (max-width: ${theme.sz.md}) {
              padding: ${theme.sz.s4};
              background-color: ${theme.co.neutral99};
            }
          `
    }
  `,
);

export const ContentWrapper = styled.div(
  ({ theme }) => css`
    width: 100%;
    max-width: ${theme.sz.md};
    display: flex;
    flex-direction: column;
  `,
);

export const Header = styled.div(
  ({ theme }) => css`
    position: relative;
    background-color: ${theme.co.primary60};
    padding: ${theme.sz.s2} ${theme.sz.s5} ${theme.sz.s5} ${theme.sz.s5};
    border-radius: ${theme.sz.s3};
    display: flex;
    flex-direction: column;
    margin-bottom: ${theme.sz.s5};

    @media (max-width: ${theme.sz.md}) {
      padding: ${theme.sz.s5} ${theme.sz.s4};
      margin: ${theme.sz.s2} -${theme.sz.s4} ${theme.sz.s2} -${theme.sz.s4};
      border-radius: 0;
      background-color: ${theme.co.primary98};
    }
  `,
);

export const TitleContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: baseline;
    gap: ${theme.sz.s1};
  `,
);

export const IconContainer = styled.div<{ $color: Color }>(
  ({ theme, $color }) => css`
    margin-bottom: ${theme.sz.s2};
    color: ${theme.co[$color]};
    font-size: ${theme.sz.s8};
  `,
);

export const Title = styled.h1(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.s};
    color: ${theme.co.secondary20};
    margin: 0;

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.heading.mobile.s};
    }
  `,
);

export const Description = styled.p(
  ({ theme }) => css`
    ${theme.typography.paragraph.base};
    color: ${theme.co.secondary20};
    margin: 0;
    z-index: ${theme.zi.z1};

    @media (max-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.m};
    }
  `,
);

export const Content = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s6};
    background-color: ${theme.co.neutral99};
    padding: ${theme.sz.s6};
    border-radius: ${theme.sz.s5};

    @media (max-width: ${theme.sz.md}) {
      padding: 0;
    }
  `,
);

export const StickyWrapper = styled.div(
  ({ theme }) => css`
    position: sticky;
    bottom: ${theme.sz.s0};
    padding: ${theme.sz.s5};
    background-color: ${theme.co.primary98};
    display: flex;
    justify-content: center;
    margin: 0 -${theme.sz.s05}; // negative margin needed to offset position sticky pixels
    gap: ${theme.sz.s3};

    @media (max-width: ${theme.sz.md}) {
      flex-direction: column;
      background-color: ${theme.co.neutral99};
      padding: ${theme.sz.s4} 0;
    }
  `,
);

export const ButtonsContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s4};

    @media (min-width: ${theme.sz.md}) {
      button {
        padding-left: ${theme.sz.s12};
        padding-right: ${theme.sz.s12};
      }
    }
  `,
);

export const StartIcon = styled(Icon)(
  ({ theme }) => css`
    margin-right: ${theme.sz.s1};
    margin-bottom: ${theme.sz.s05};
  `,
);

export const HeaderRow = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s4};
  `,
);

export const HeaderCopy = styled.div(
  () => css`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
  `,
);

export const HeaderMedia = styled.div(
  ({ theme }) => css`
    flex-shrink: 0;
    width: ${theme.sz.s24};

    @media (max-width: ${theme.sz.md}) {
      width: ${theme.sz.s20};
    }
  `,
);
